<tpm-dialog-frame
  *ngIf="contentfulInfo$ | async as contentfulInfo"
  [header]="(contentfulInfo$ | async)?.moduleName | translate"
  [closeButtonLabel]="'APP.CANCEL' | translate"
  [submitButtonLabel]="'APP.SUBMIT_REQUEST' | translate | uppercase"
  [submitDisabled]="leadForm.invalid"
  submitForm="teaserForm"
>
  <div class="lead-dialog-content">
    <div class="headline top contentful">
      <h2 class="headline-3">{{ contentfulInfo.headline1 }}</h2>
      <div class="rich-text" [innerHTML]="contentfulInfo.text1"></div>
    </div>
    <div class="left contentful">
      <div class="headline">
        <h2 class="headline-2">{{ contentfulInfo.headline2 }}</h2>
        <div class="rich-text" [innerHTML]="contentfulInfo.text2"></div>
      </div>
      <div class="flyer" *ngIf="contentfulInfo.action" (click)="downloadFlyer(contentfulInfo.action)">
        <mat-icon fontIcon="ec_download"></mat-icon>
        <span>{{ "LEAD.DOWNLOAD_FLYER" | translate : translationParams }}</span
        ><span class="type">(pdf)</span>
      </div>

      <app-contentful-media [asset]="contentfulInfo.media?.fields?.file" class="media"> </app-contentful-media>
    </div>
    <div class="right">
      <div class="contact">
        <h2 class="headline-2">{{ "LEAD.FORM_TITLE" | translate }}</h2>
        <p>{{ "LEAD.FORM_SUBTITLE" | translate }}</p>
        <div class="contact__card" *ngIf="contactPerson$ | async as contactPerson">
          <img class="contact__card-photo" src="/assets/images/logos/tenant-0001.svg" />
          <div class="contact__card-text">
            <h3 class="subtitle-1">{{ "APP.CONTACT_PERSON" | translate }}:</h3>
            <p>
              <span *ngIf="contactPerson.givenName as givenName">{{ givenName }}&nbsp;</span>
              <span *ngIf="contactPerson.familyName as familyName">{{ familyName }}</span>
            </p>
            <p *ngIf="contactPerson.phoneNumber as phoneNumber">Telefon: {{ phoneNumber }}</p>
            <p>
              <span>E-Mail:</span>
              <a class="link-1" href="mailto:{{ contactPerson.email }}" (click)="trackEmail()">
                {{ contactPerson.email }}
              </a>
            </p>
          </div>
        </div>
      </div>
      <form
        #teaserForm
        id="teaserForm"
        name="teaserForm"
        class="lead-form"
        [formGroup]="leadForm"
        (submit)="submit($event)"
      >
        <mat-radio-group formControlName="communicationType" name="communicationType">
          <mat-radio-button class="small" [value]="item.id" *ngFor="let item of communicationTypes">
            <b [innerHTML]="item.key | translate"></b>
          </mat-radio-button>
        </mat-radio-group>

        <tpm-input-field
          [class.hidden]="communicationType?.value !== 'phone'"
          placeholder="Telefonnummer eingeben"
          formControlName="phoneNumber"
          name="phoneNumber"
          [label]="'Telefonnummer'"
        ></tpm-input-field>
        <tpm-checkbox
          [class.hidden]="communicationType?.value !== 'phone'"
          class="phonenumber-checkbox"
          density="small"
          formControlName="itsMyPhone"
          name="itsMyPhone"
          [label]="'Hiermit bestätige ich, dass es sich um meine eigene Mobilfunknummer handelt.' | translate"
        ></tpm-checkbox>

        <tpm-input-field
          [class.hidden]="communicationType?.value !== 'email'"
          placeholder="E-Mail eingeben"
          formControlName="email"
          name="email"
          [label]="'E-Mail-Adresse'"
        ></tpm-input-field>

        <tpm-textarea-field
          name="text"
          [label]="'Anmerkungen'"
          formControlName="text"
          name="text"
          placeholder="Text eingeben"
        ></tpm-textarea-field>

        <input type="hidden" formControlName="givenName" name="givenName" />
        <input type="hidden" formControlName="familyName" name="familyName" />
        <input type="hidden" formControlName="moduleMarketingGuid" name="moduleMarketingGuid" />
        <input type="hidden" formControlName="ags" name="ags" />

        <div class="legal">
          <p class="legal-info" [innerHTML]="'LEAD.LEGAL_INFO' | translate : translationParams"></p>
          <div *ngIf="leadForm.contains('agreement')" class="agreement-checkbox-wrapper">
            <tpm-checkbox density="small" formControlName="agreement" name="agreement"></tpm-checkbox>
            <span [innerHTML]="'LEAD.AGREEMENT_CHECKBOX_LABEL' | translate : agreementTranslationParams"></span>
          </div>
          <p>{{ "LEAD.ENCRYPTION_DISCLAIMER" | translate }}</p>
          <a class="link-1" (click)="openDialog()">{{ "APP.READ_DATAPROTECTION_INFO" | translate }}</a>
        </div>
      </form>
    </div>
  </div>
</tpm-dialog-frame>
